








import Vue from 'vue'
import AppBar from '@/components/appBase/AppBar.vue'
import MainNav from '@/components/appBase/MainNav.vue'

export default Vue.extend({
  name: 'AppLayout',
  components: { AppBar, MainNav },
  data: () => ({
    showNav: false,
  }),
  methods: {
    toggleNav() {
      this.showNav = !this.showNav
    },
  },
})

